module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxODAwIiBoZWlnaHQ9IjExMDAiPjxwYXRoIGZpbGw9IiNmZmYiIGQ9Ik0wIDBoMTgwMHYxMTAwSDB6Ii8+PHBhdGggZmlsbD0iIzAwMzU4MCIgZD0iTTAgNDAwaDE4MDB2MzAwSDB6Ii8+PHBhdGggZmlsbD0iIzAwMzU4MCIgZD0iTTUwMCAwaDMwMHYxMTAwSDUwMHoiLz48L3N2Zz4="


//////////////////
// WEBPACK FOOTER
// ./src/assets/flags/fin.svg
// module id = R/GH
// module chunks = 0